<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import axios from 'axios'

    import VirtualList from '../../components/VirtualList/VirtualList.svelte'
    import ListItem from '../../components/ListItem/ListItem.svelte'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    import FadeinFX from '../../components/FX/FadeinFx.svelte'
    import ListFilter from './ListFilter.svelte'

    
    export let items = []
    export let height = '390px'

    const dispatch = createEventDispatcher ();
</script>

<style>
    .ListChooser :global(svelte-virtual-list-viewport) {
        padding: 10px;
    }
    .ListChooser {
        position: relative;
    }
</style>

{#if items}
    <div class="ListChooser">
        <!-- <ListFilter on:filter={onListFilter} /> -->
        <!-- <FadeinFX durationOut={0}> -->
            <VirtualList {items} {height} let:item>
                <div class="ClientItem clearfix">
                    <ListItem classes="block with-icon clearfix" actions on:click={e => dispatch ('select', item)}>
                        <div class="icon">
                            <i class="fad fa-map-marker-alt"></i>
                        </div>
                        <div class="meta">
                            <div class="lbl">{item.name}</div>
                            <div class="txt">{item.street}</div>
                            <div class="txt">{item.city}</div>
                        </div>
                        
                        <div slot="actions">
                            <ActionButton icon="far fa-arrow-left" on:click={e => dispatch ('select', item)} />
                        </div>
                    </ListItem>
                </div>
            </VirtualList>
        <!-- </FadeinFX> -->
    </div>
{/if}